import { render, staticRenderFns } from "./PatternB.vue?vue&type=template&id=854e1486&scoped=true&"
import script from "./PatternB.vue?vue&type=script&lang=js&"
export * from "./PatternB.vue?vue&type=script&lang=js&"
import style0 from "./PatternB.vue?vue&type=style&index=0&id=854e1486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854e1486",
  null
  
)

export default component.exports